// © 2026 AttainIP Engineering
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { AdminPrefsProvider } from './lib/adminPrefs';
import './styles.css';
import 'katex/dist/katex.min.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AdminPrefsProvider>
        <App />
      </AdminPrefsProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
